import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";
import LoadingSpinner from "../../components/common/LoadingSpinner";
import { useOAuth } from "../../auth/OAuthProvider";

// OAuth callback handler - extracts tokens from URL and stores them
export const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useOAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('🔄 OAuthCallback - Starting callback handler...');
        console.log('🔄 OAuthCallback - User-Agent:', navigator.userAgent);
        console.log('🔄 OAuthCallback - Platform:', navigator.platform);
        console.log('🔄 OAuthCallback - Cookies enabled:', navigator.cookieEnabled);
        
        // Small delay to ensure cookie is fully written (helps with Mac Chrome)
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Cookies are already set by backend, just refresh user state
        await refreshUser();
        console.log('✅ OAuthCallback - User refreshed, navigating to home...');

        // Redirect to home
        navigate("/", { replace: true });
        console.log('✅ OAuthCallback - Navigate called');
      } catch (error) {
        console.error('❌ OAuthCallback - Error during callback:', error);
        // On error, redirect to login
        navigate("/login", { replace: true });
      }
    };

    handleCallback();
  }, [navigate, refreshUser]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
      }}
    >
      <LoadingSpinner text="Completing sign in..." />
    </Box>
  );
};
